import { defineComponent, h } from 'vue'
import { PontotelBotao, PontotelBotaoIcone } from '@Lar21/imaginii-web-components/lib/vue'

export default defineComponent({
  name: 'PConfirmButton',
  inheritAttrs: false,
  emits: ['clique'],
  props: {
    text: String,
    somenteIcone: Boolean
  },
  methods: {
    async handleClick (event) {
      if (!await this.$modalDeConfirmacao({ text: this.text })) return
      this.$emit('clique', event)
    }
  },
  render () {
    const componente = this.somenteIcone ? PontotelBotaoIcone : PontotelBotao
    const slots = this.somenteIcone
      ? { icone: () => this.$slots.default?.() }
      : { default: () => this.$slots.default?.() }

    return h(componente, { ...this.$attrs, onClique: this.handleClick }, slots)
  }
})
